export default {
  'Submit': 'Soumettre',
  'Save': 'Enregistrer',
  'enterOTP': 'Confirmez votre numéro de téléphone',
  'otpSent': 'Mot de passe unique envoyé',
  'login/signup': 'Se connecter/s’inscrire',
  'resendCode': 'Renvoyer le code',
  'edit': 'Modifier',
  'otpMessage': 'Un code à 6 chiffres a été envoyé sur votre numéro de téléphone.',
  'oyo360WelcomeMessage': 'Bienvenue sur OYO',
  'oyo360ResendCode': 'Renvoyer le code',
  'oyo360Edit': 'Modifier',
  'oyo360otpMessage': 'Entrez le code que nous avons envoyé via SMS à votre numéro de mobile',
  'buttonActionContinue': 'Continuer',
  'chooseLanguage': 'Choisir une langue',
  'currentLanguage': 'LANGUE ACTUELLE',
  'otherLanguages': 'AUTRES LANGUES',
  'google': 'Continuer avec Google',
  'facebook': 'Continuer avec Facebook',
  'or': 'ou',
  'buttonActionSubmit': 'Envoyer',
  'welcomeTitle': 'Bienvenue chez OYO',
  'welcomeHeadingForMailLogin': `Entrez l'adresse email associée`,
  'welcomeHeadingForPhoneLogin': 'Entrez le numéro de mobile associé',
  'emailIdLabel': 'Adresse email',
  'phoneNumberLabel': 'Numéro de téléphone',
  'passwordLabel': 'Mot de passe',
  'newPasswordLabel': 'Nouveau mot de passe',
  'confirmNewPasswordLabel': 'Confirmer le nouveau mot de passe',
  'emailErrorMessage': 'Veuillez entrer une adresse email correcte',
  'phoneNumberErrorMessage': 'Veuillez entrer un numéro de téléphone correct',
  'passwordErrorMessage': 'Veuillez entrer le bon mot de passe',
  'confirmPasswordErrorMessage': 'Le mot de passe ne correspond pas !',
  'generateNewPassword': 'Générer un nouveau mot de passe',
  'loginButtonLabel': 'Se connecter',
  'loginWithPhoneButtonLabel': 'Continuer avec le téléphone',
  'loginWithOtp': 'Se connecter avec un mot de passe à usage unique (OTP) à la place',
  'loginWithEmailButtonLabel': 'Continuer avec l’adresse email',
  'back': 'Retour',
  'loginWithOtpTitle': 'Entrez le code de vérification',
  'loginWithOtpHeading': 'Un code à 6 chiffres a été envoyé sur votre numéro de téléphone.',
  'listYourProperty': 'Mettez en ligne votre propriété',
  'privacyPolicy': 'politique de confidentialité',
  'verifyEmail': `Vérifier l'adresse email`,
  'verifyMobile': 'Vérifier le numéro de téléphone',
  'forgotPasswordPhoneSubHeading': 'Nous vous enverrons un code à 6 chiffres pour vérifier votre numéro de téléphone.',
  'forgotPasswordMailSubHeading': 'Nous vous enverrons un code à 6 chiffres pour vérifier votre adresse email.',
  'newPasswordCondition1': 'Doit comporter à la fois un chiffre et un symbole',
  'newPasswordCondition2': 'Doit avoir au moins 8 caractères',
  'newPasswordCondition3': 'Doit comporter à la fois des minuscules et des majuscules.',
  'confirmLogin': 'Confirmer et se connecter',
  'getOTP': 'Recevoir le mot de passe à usage unique (OTP)',
  'invalidInput': 'Entrée non valide',
  'passwordResetMessage': 'Mot de passe généré avec succès',
  'otpErrorMessage': 'Veuillez entrer le bon mot de passe à usage unique',
  'resendOtpSuccessMessage': 'Le mot de passe a été renvoyé avec succès sur votre numéro de mobile.',
  'InternalServerErrorMessage': 'Erreur de serveur interne',
  'resetPasswordHeading': 'Un code à 6 chiffres a été envoyé à votre adresse email et à votre numéro de téléphone.',
  'signingIn': 'Ouverture de la session',
  'invalidMobileNumber': 'Numéro de mobile invalide',
  'privacyFooterText': 'En vous connectant à votre compte, vous acceptez nos {termsOfUse} et notre {privacyPolicy}',
  'and': 'et',
  'termsOfUse': `conditions d'utilisation`,
  'listProperty': 'Propriété de la liste',
  'whiteSpace': ' ',
  'facingIssue': 'Facing any issue? ',
  'oldLoginViewSwitch': 'Switch to Old view',
  'mobileNumberPlaceholder': 'Entrez le numéro de téléphone',
  'secureInformation': 'Pas d\'inquiétude, vos informations sont sécurisées avec nous',
  'termsOfService': 'Conditions d\'utilisation',
  'termsOfServiceFooter': 'En sélectionnant Continuer ci-dessous, j\'accepte les {termsOfService} suivantes',
  'loginSubText': 'Veuillez entrer votre numéro de téléphone pour devenir une maison de vacances Belvilla en seulement 30 minutes',
  'mobileSearchPlaceholder': 'Rechercher',
  'passwordChangeInformationText': 'Vous serez déconnectés de tous vos équipements une fois votre mot de passé modifié.'
};
